interface StatusBadgeProps {
  status: "REJECTED" | "PENDING" | "APPROVED" | "PASS";
}

const statusStyles: Record<StatusBadgeProps["status"], string> = {
  APPROVED: "bg-green-600 text-white",
  PENDING: "bg-red-500 text-white",
  REJECTED: "bg-blue-500 text-white",
  PASS: "bg-orange-400 text-white",
};

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  return (
    <span
      className={`px-3 py-1 text-sm font-semibold rounded-full inline-block ${statusStyles[status]}`}
    >
      {status}
    </span>
  );
};
